import { useMemo, useReducer } from 'react';

export const useCreateReducer = (actionMap, initialState, init) => {
  const reducer = useMemo(() => {
    return (state, action) => (actionMap[action.type] ? actionMap[action.type](state, action) : state);
  }, [actionMap]);

  return useReducer(reducer, initialState, init);
};
